import type { AddProductsFormData } from './types'

export const DEFAULT_VALUES: AddProductsFormData = {
  filterName: 'name',
  filterValue: ''
}
